import { Box, BoxProps, EmptyView, Loader } from '@jfs/ui-new'

interface ContainerProps {
  children?: any
  isLoading?: any
  errorMessage?: string
  emptyMessage?: string
  onRetry?: any
  style?: BoxProps
}

export const Container = ({ children, isLoading, errorMessage, emptyMessage, onRetry, style = {} }: ContainerProps) => {
  const shouldShowEmptyView = () => isLoading || errorMessage || emptyMessage
  return (
    <Box {...{ ...styles.container, ...style }}>
      {shouldShowEmptyView() && (
        <Box height={'100%'} flex={1} justifyContent={'center'}>
          <EmptyView
            onRetry={onRetry}
            isLoading={isLoading}
            loaderComponent={<Loader type="large" color="PRIMARY" />}
            emptyMessage={emptyMessage}
            error={errorMessage && { networkError: { data: { errors: [{ details: errorMessage }] } } }}
          />
        </Box>
      )}
      {!shouldShowEmptyView() && children}
    </Box>
  )
}

const styles = {
  container: {
    f: 1,
  } as BoxProps,
}
